import moment from "moment";
import { ENCRYPTION_PRIVATE_KEY } from "./constants";

export const isImageUrl = (url) => {
  const imageExtensions = /\.(png|jpe?g|gif|svg|jpg)$/i;
  return typeof url === "string" && imageExtensions.test(url);
};

export const copyText = (val, setLoading) =>
  navigator.clipboard.writeText(val).then(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 2000);
  });

export const handleCopyText = (val) => {
  navigator.clipboard.writeText(val).then(() => { });
};

export const formatDate = (date) => date.toISOString().split("T")[0]; // Format date to YYYY-MM-DD

export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === "string" && !value.trim() && value.length) ||
  (typeof value === "object" && !Object.keys(value).length);

export const formatToTwoDecimalPlaces = (value) => {
  const number = parseFloat(value);
  if (isNaN(number)) return "Invalid number";
  return number.toFixed(2);
};

export const formattedTimeZone = () => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTime = moment()?.format("DD/MM/YYYY - HH:mm:ss z");

  return formattedTime;
};

export const FETCH_DATE_AFTER_SELECTION = (selectedDate, chosenDate) => {
  let startDate = "",
    endDate = "";

  if (selectedDate === "today") {
    startDate = moment().utc().startOf("day");
    endDate = moment().utc().endOf("day");
  } else if (selectedDate === "yesterday") {
    startDate = moment().utc().subtract(1, "days").startOf("day");
    endDate = moment().utc().subtract(1, "days").endOf("day");
  } else if (selectedDate === "7days") {
    startDate = moment().utc().subtract(7, "days").startOf("day");
    endDate = moment().utc().endOf("day");
  } else if (selectedDate === "month") {
    startDate = moment().utc().startOf("month");
    endDate = moment().utc().endOf("month");
  } else if (chosenDate?.startDate && chosenDate?.endDate) {
    startDate = moment.utc(chosenDate.startDate).startOf("day");
    endDate = moment.utc(chosenDate.endDate).endOf("day");
  }
  return { startDate, endDate };
};

export const MERGED_SESSIONS_USERS = (sessions) => {
  const userMap = new Map();

  sessions.forEach((session) => {
    const userIdStr = session.userId.toString();

    if (userMap.has(userIdStr)) {
      // Update existing user by summing up values
      const existingUser = userMap.get(userIdStr);
      existingUser.transferDebit += session.transferDebit;
      existingUser.transferCredit += session.transferCredit;
    } else {
      // Add new user
      userMap.set(userIdStr, { ...session });
    }
  });

  return Array.from(userMap.values());
};

export const calculateTotalTransfer = (sessions, type) => {
  if (!Array.isArray(sessions)) return 0;

  return sessions.reduce((sum, session) => sum + (session[type] || 0), 0);
};

export const calculateTotalMargin = (sessions) => {
  if (!Array.isArray(sessions)) return 0;

  return sessions.reduce((sum, game) => {
    const margin = ((game.transferCredit - game.transferDebit) * game.transferCredit) / 100;
    return sum + margin;
  }, 0);
};
export const calculateTotalProfitLoss = (sessions) => {
  if (!Array.isArray(sessions)) return 0;

  return sessions.reduce((sum, game) => {
    const margin = game.transferCredit - game.transferDebit;
    return sum + margin;
  }, 0);
};

export const ENCRYPTION_OF_DATA = async (data) => {
  if (!ENCRYPTION_PRIVATE_KEY) {
    throw new Error("Encryption key not found");
  }

  // Generate random IV (12 bytes for GCM)
  const iv = window.crypto.getRandomValues(new Uint8Array(12));

  // Ensure key is exactly 32 bytes (256 bits)
  const keyBytes = new TextEncoder().encode(ENCRYPTION_PRIVATE_KEY).slice(0, 32);
  if (keyBytes.length !== 32) {
    const paddedKey = new Uint8Array(32);
    paddedKey.set(keyBytes);
    keyBytes = paddedKey;
  }

  // Import the key
  const key = await window.crypto.subtle.importKey("raw", keyBytes, "AES-GCM", false, ["encrypt"]);

  // Encrypt the data
  const encodedData = new TextEncoder().encode(JSON.stringify(data));
  const encryptedContent = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
      tagLength: 128,
    },
    key,
    encodedData
  );

  // Convert to Base64
  const encryptedBase64 = btoa(String.fromCharCode(...new Uint8Array(encryptedContent)));
  const ivBase64 = btoa(String.fromCharCode(...iv));

  return {
    encryptedData: encryptedBase64,
    iv: ivBase64,
  };
};

export const CHECK_SELECTED_USER_ID = (selectedUser) => {
  if (selectedUser["User"]) {
    return { key: "User", value: selectedUser["User"] }
  } else if (selectedUser["Agent"]) {
    return { key: "Agent", value: selectedUser["Agent"] }
  } else if (selectedUser["SuperAgent"]) {
    return { key: "SuperAgent", value: selectedUser["SuperAgent"] }
  } else if (selectedUser["Partner"]) {
    return { key: "Partner", value: selectedUser["Partner"] }
  }
  return { key: "", value: "" }
}
